import React from 'react'
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock } from 'react-bootstrap'
import { updateUserInfo } from '../api'
import { Modal } from 'react-bootstrap'
import { getTimeZoneEnumParser } from '../shared/enums/timezone-enum-parser'

let newPassword = ''
let confirmPassword = ''
let passwordMatch = false
let passwordNull = true
let passwordHelp = ''

const InfoModal = React.createClass({
  getInitialState: function () {
    return {
      name: '',
      email: '',
      phone: '',
      password: '',
      passwordConfirm: '',
      timeZone: '',
      vsState: null,
      currentPassVState: null,
      errorMessage: ''
    }
  },
  componentDidMount: function () {
    this.setState({
      name: this.props.info.name,
      email: this.props.info.email,
      phone: this.props.info.phone,
      password: '',
      passwordConfirm: '',
      passwordCurrent: '',
      timeZone: getTimeZoneEnumParser(this.props.info.timeZone)
    })
  },
  doPasswordsMatch: function () {
    if (confirmPassword || newPassword) {
      if (confirmPassword.length > 0 || newPassword.length > 0) {
        if (confirmPassword === newPassword) {
          passwordMatch = true
          passwordNull = false
          this.setState({vsState: 'success'})
        } else {
          passwordMatch = false
          passwordNull = false
          this.setState({vsState: 'error'})
        }
      }
    } else {
      passwordMatch = false
      passwordNull = true
      this.setState({vsState: null})
    }
  },
  handleInputChange: function (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({[name]: value})

    if (name === 'passwordConfirm') {
      confirmPassword = value
      this.doPasswordsMatch()
    } else if (name === 'password') {
      newPassword = value
      this.doPasswordsMatch()
    }
  },
  changePassword: function () {
    var email = this.props.loginData.customer.loginName;
    var redirectURI = window.location.href;
    var currentURL = new URL(redirectURI)
    redirectURI = currentURL.origin;
    var userRegistrationURL = this.props.loginData.userRegistrationURL;
    var changePassURL = userRegistrationURL + "change-password?email=" + email + "&redirectURI=" + redirectURI +"&redirectAfterDone=true" ;
    window.location.replace(changePassURL);
  },
  closeModal: function () {
    this.setState({vsState: null, currentPassVState: null, errorMessage: ''})
    this.props.hide()
  },
  submitInfo: function (event) {
    event.preventDefault()
    let name = this.state.name
    let email = this.state.email
    let timeZone = this.state.timeZone
    let cell = this.state.phone
    let password = newPassword
    let currentPassword = this.state.passwordCurrent

    if (passwordMatch === true && currentPassword === '') {
      this.setState({currentPassVState: 'error', errorMessage: 'Passwords must match'})
    } else if (passwordMatch === true) {
      updateUserInfo(name, email, timeZone, cell, password, currentPassword).then((response) => {
        if (response !== 'okay') {
          if(response.includes("update your password")) {
            this.setState({errorMessage: 'Cannot use a previous password', vsState: 'error', currentPassVState: null})
          }
          else {
            this.setState({errorMessage: 'Incorrect password', vsState: null, currentPassVState: 'error'})
          }
        } else {
          this.props.update(email, name, cell)
          this.closeModal()
        }
      })
    } else if (passwordNull === true) {
      updateUserInfo(name, email, timeZone, cell, password, currentPassword).then((response) => {
        if (response !== 'okay') {
          this.setState({})
        } else {
          this.props.update(email, name, cell)
          this.closeModal()
        }
      })
    } else {
        this.setState({errorMessage: "Passwords must match"})
    }
  },
  render: function () {
    let keycloakToken = JSON.parse(sessionStorage.getItem("keycloakToken"));
    return (
      <div >
        <Modal show={this.props.show} onHide={this.closeModal}>
          <div className='white-background'>
            <Modal.Header closeButton>
              <div className='col-xs-1'/>
              <div className='center-block col-xs-10'>
                <h2 className='text-center'>Edit My Info</h2>
                <br />
                <form method='POST'>
                  <FormGroup bsClass='form-group' className={this.state.name ? 'has-value' : ''} controlId='updateUserName'>
                    <ControlLabel>Name</ControlLabel>
                    <FormControl value={this.state.name} type='text' name='name' onChange={this.handleInputChange}/>
                  </FormGroup>
                  <FormGroup bsClass='form-group' className={this.state.email ? 'has-value' : ''} controlId='updateUserEmail'>
                    <ControlLabel>Email</ControlLabel>
                    <FormControl value={this.state.email} type='text' name='email' onChange={this.handleInputChange}/>
                  </FormGroup>
                  <FormGroup bsClass='form-group' className={this.state.phone ? 'has-value' : ''} controlId='updateUserCell'>
                    <ControlLabel>Cell Number</ControlLabel>
                    <FormControl value={this.state.phone} type='text' name='phone' onChange={this.handleInputChange}/>
                  </FormGroup>
                  {keycloakToken && keycloakToken.isEmpty?
                      <div className='well well-lg concrete-gray-background pull-down-xs-4'>
                        <h4 className='text-center'>Change Password</h4>
                        <FormGroup className={this.state.passwordCurrent ? 'has-value pull-down-xs-2' : 'pull-down-xs-2'} validationState={this.state.currentPassVState}>
                          <ControlLabel>Current Password</ControlLabel>
                          <FormControl type='password' name='passwordCurrent' onChange={this.handleInputChange}/>
                          <HelpBlock>{passwordHelp}</HelpBlock>
                        </FormGroup>
                        <FormGroup className={this.state.password ? 'has-value' : ''} controlId='updateUserPassword' validationState={this.state.vsState}>
                          <ControlLabel>New Password</ControlLabel>
                          <FormControl type='password' name='password' onChange={this.handleInputChange}/>
                        </FormGroup>
                        <FormGroup className={this.state.passwordConfirm ? 'has-value' : ''} controlId='updateUserPasswordConfirm' validationState={this.state.vsState}>
                          <ControlLabel>Confirm New Password</ControlLabel>
                          <FormControl type='password' name='passwordConfirm' onChange={this.handleInputChange}/>
                        </FormGroup>
                        <div className='text-center'>
                          <p className='red-color'>{this.state.errorMessage}</p>
                        </div>
                      </div>
                       :
                      <FormGroup>
                        <Button bsClass='btn custom-btn btn-sm center-block' onClick={this.changePassword}>
                        Change Password
                      </Button>
                    </FormGroup>
                  }

                  <FormGroup>
                    <Button bsClass='btn btn-success btn-sm center-block' onClick={this.submitInfo}>
                    Update Info
                  </Button>
                  </FormGroup>
                </form>
              </div>
            </Modal.Header>
          </div>
        </Modal>
      </div>
    )
  }
})

export default InfoModal



// WEBPACK FOOTER //
// ./src/components/modals/account-info-modal.jsx